// extracted by mini-css-extract-plugin
export default {"besiness_msp":"MSP_besiness_msp__XjoiY","service":"MSP_service__yFkWc"};